// MARK://dhk8/admin-shell/components/ErrorBoundary
// Catches render crashes in a page so the shell stays usable. Copied from the POS app.
import React from 'react'

interface State { error: Error | null }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  override state: State = { error: null }
  static getDerivedStateFromError(error: Error): State { return { error } }
  override componentDidCatch(error: Error) { console.error('[admin] render error', error) }
  override render() {
    if (this.state.error) {
      return (
        <div className="adm-card adm-banner--danger" role="alert">
          <strong>Algo falló al renderizar esta pantalla.</strong>
          <div style={{ marginTop: 8, fontSize: 13 }}>{this.state.error.message}</div>
          <button className="adm-btn adm-btn--sm" style={{ marginTop: 12 }} onClick={() => this.setState({ error: null })}>Reintentar</button>
        </div>
      )
    }
    return this.props.children
  }
}
